import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/insurance';

export type Claims = Awaited<ReturnType<(typeof service)['getClaims']>>;

export function getClaimsOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Claims>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['insurances', 'claims', guid, [search]],
    queryFn: async () => await service.getClaims(guid, search),
    initialData,
  });
}
